import { render, staticRenderFns } from "./LocalizedDatepicker.vue?vue&type=template&id=4944ddbe"
import script from "./LocalizedDatepicker.vue?vue&type=script&lang=js"
export * from "./LocalizedDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports